<template>
	<div class="base-tab">
		<ul class="base-tab-element" v-for="tab in tabs" :key="tab">
			<li
				@click="handleClick(tab)"
				:class="{ 'active-tab': activeTab === tab.toLowerCase() }"
			>{{ tab }}</li>
		</ul>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'BaseTab',
	data() {
		return {
			tabs: ['New', 'Processing', 'Approved', 'Completed']
		}
	},
	computed: {
		...mapState({
			activeTab: state => state.job.activeTab
		})
	},
	props: {
		changeActiveTab: {
			type: Function,
			required: true
		}
	},
	methods: {
		handleClick(tab) {
			this.$store.dispatch('job/setActiveTab', {
				activeTab: tab.toLowerCase()
			})
			this.changeActiveTab()
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/baseTab.scss';
</style>
